import React, { useEffect, useState } from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <div className="hero-container">
      {/* Animated Background */}
      <div className="animated-background"></div>

      {/* Content */}
      <div
        className={`hero-content transition-opacity duration-1000 ${
          fadeIn ? "opacity-100" : "opacity-0"
        } translate-y-0`}
      >
        <h1 className="hero-title">
          This is <span className="text-glow">Wayne Wang,</span>
        </h1>
        <p className="hero-subtitle">
          Your utility guy in{" "}
          <span className="label software-engineer">&lt;AI/ML Engineering /&gt;</span>,{" "}
          <span className="label ai-researcher">&lt;LLM Engineering /&gt;</span>, and{" "}
          <span className="label">&lt;AI Research /&gt;</span>,
        </p>
        <p className="text-gray-500">and a part-time car mechanic.</p>
      </div>
    </div>
  );
};

export default HeroSection;